<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row class="mb-2">
        <b-col>
          <button class="btn btn-sm btn-warning" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
          <router-link v-if="ableToUpdateDevice" class="btn" :to="{name: 'EXCMDeviceUpdate', params: { id: item['@id'] }}">
            {{ $t('buttons.edit') }}
          </router-link>
          <button v-if="ableToUpdateDevice" class="btn btn-sm btn-danger" @click="deleteItem(item)">
            <span v-if="!mobileView">{{$t('buttons.delete')}}</span>
            <i v-else class="far fa-trash-alt"></i>
          </button>
          <router-link v-if="prevRoute.name === 'Overview'" :to="{ name: 'Overview' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToDashboard')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-if="prevRoute.name === 'EXCMAgreementDeviceList'" :to="{ name: 'EXCMAgreementDeviceList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMDeviceList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-tabs content-class="mt-3">
            <b-tab :title="$t('views.profile.index.tabs.info')">
              <b-row>
                <b-col lg="9">
                  <b-card>
                    <b-row>
                      <b-col md="9">
                        <p><b>{{$t('views.excmdevice.show.id')}}</b> - {{ item.id }}</p>
                        <p><b>{{$t('views.excmdevice.show.type')}}</b> - {{item.idDeviceModel.idDeviceType.title}}</p>
                        <p><b>{{$t('views.excmdevice.show.brand')}}</b> - {{item.idDeviceModel.idDeviceType.brandTitle}}</p>
                        <p><b>{{$t('views.excmdevice.show.model')}}</b> - {{item.idDeviceModel.model}}</p>
                        <p><b>{{$t('views.excmdevice.show.serialNumber')}}</b> - {{item.serialNumber}}</p>
                      </b-col>
                      <b-col md="3" align-self="end">
                        <div class="float-right" style="cursor: pointer;" @click="downloadPDF(getIdLink(item['@id']), item.serialNumber)" v-b-tooltip.hover :title="$t('views.excmdevice.show.downloadPDF')">
                          <qr-code :text="item['@id']"></qr-code>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <ClientSecton :item="item" :retrieve="retrieve"></ClientSecton>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <span class="h6 mb-2">{{$t('views.excmdevice.show.localization')}}: </span>
                        <p v-if="item.city"><b>{{$t('views.excmdevice.form.city')}}:</b> {{item.postcode}} {{item.city}} </p>
                        <p v-if="item.street"><b>{{$t('views.excmdevice.form.street')}}:</b> {{item.street}} </p>
                        <p v-if="item.floor"><b>{{$t('views.excmdevice.form.floor')}}:</b> {{item.floor}} </p>
                        <p v-if="item.room"><b>{{$t('views.excmdevice.form.room')}}:</b> {{item.room}}</p>
                        <p v-if="item.idContractorUserData"><b>{{$t('views.excmcase.form.contractorUserData')}}:</b>
                          <span v-if="item.idContractorUserData.fullName">{{item.idContractorUserData.fullName}}</span>
                          <span v-if="item.idContractorUserData.firmname1">{{item.idContractorUserData.firmname1}}</span>
                        </p>
                      </b-col>
                      <b-col cols="12" lg="6" v-if="item.latitude && item.longitude">
                        <div class="map" id="map" style="height: 40vh; width: 100%;" ref="mapElement">
                          <l-map :zoom="zoom" :center="{lat: parseFloat(item.latitude), lng: parseFloat(item.longitude)}">
                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                            <l-marker :lat-lng="{lat: parseFloat(item.latitude), lng: parseFloat(item.longitude)}">
                            </l-marker>
                          </l-map>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
                <b-col lg="3" sm="12" v-if="item">
                  <time-line type="simple">
                    <time-line-item inverted badge-type="success" badge-icon="">
                      <b-badge slot="header" variant="success">{{$t('views.excmdevice.show.deviceCreated')}}</b-badge>
                      <p slot="content"></p>
                      <h6 slot="footer">
                        {{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}
                      </h6>
                    </time-line-item>
                    <time-line-item inverted v-for="singleCase in item.cases" v-bind:key="singleCase.id" badge-type="info" badge-icon="">
                      <b-badge slot="header" variant="info" class="link" @click="$router.push({name: 'EXCMCaseShow', params: { id: singleCase['@id'] }})">
                        {{singleCase.caseType.title}}
                      </b-badge>
                      <div slot="content">
                        <p v-if="singleCase.statusModified">
                          {{$t('views.excmcase.show.finished')}} -{{$moment(singleCase.statusModified).format('YYYY-MM-DD HH:mm')}}
                        </p>
                      </div>
                      <h6 slot="footer">
                        {{$t('views.excmdevice.show.created')}} - {{$moment(singleCase.createdAt).format('YYYY-MM-DD HH:mm')}}
                      </h6>
                    </time-line-item>
                  </time-line>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab v-if="checkRoles('devices', 'EXCMDeviceStateList')" :title="$t('views.timetable.dashboard.statistics.header')">
              <b-row>
                <b-col>
                  <DeviceStateList :idDevice="$route.params.id" />
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TimeLine from 'src/components/UIComponents/TimeLine/TimeLine'
import TimeLineItem from 'src/components/UIComponents/TimeLine/TimeLineItem'
import getId from '@/utils/getIdFromLink'
import ClientSecton from './components/sections/ClientSecton'
import DeviceStateList from 'src/components/Dashboard/Views/excmdevicestate/List'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'

export default {
  computed: {
    ...mapGetters({
      deleteError: 'excmdevice/del/error',
      error: 'excmdevice/show/error',
      isLoading: 'excmdevice/show/isLoading',
      item: 'excmdevice/show/retrieved'
    }),
    ableToUpdateDevice () {
      return this.checkRoles('agreements', 'EXCMDevicesUpdate')
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    devicePeripheralUpdated () {
      return this.$store.state.modals.excmdeviceperipheraldevice.update.updated
    },
    devicePeripheralCreated () {
      return this.$store.state.modals.excmdeviceperipheraldevice.create.created
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceShow')
  },

  components: {
    LMap,
    LTileLayer,
    LMarker,
    // LPopup,
    TimeLine,
    TimeLineItem,
    ClientSecton,
    DeviceStateList,
    Loader
  },

  data () {
    return {
      prevRoute: '',
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '<a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
    let id = getId(this.$route.params.id)
    this.$store.state.Pusher.unsubscribe('e_x_c_m_devices-' + id)
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
    let id = getId(this.$route.params.id)
    this.channelDevicesRooms = this.$store.state.Pusher.subscribe('e_x_c_m_devices-' + id)
    this.channelDevicesRooms.bind('e_x_c_m_devices-' + id, data => {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    })
  },

  watch: {
    devicePeripheralCreated: function (change) {
      if (change === 1) {
        this.item = {}
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.$store.state.modals.excmdeviceperipheraldevice.create.created = 0
      }
    },
    devicePeripheralUpdated: function (change) {
      if (change === 1) {
        this.item = {}
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.$store.state.modals.excmdeviceperipheraldevice.update.updated = 0
      }
    }
  //   item: function (showItem) {
  //     for (let i in showItem.deviceAgreements) {
  //       showItem.deviceAgreements[i].agreement.dateFrom = this.$moment(showItem.deviceAgreements[i].agreement.dateFrom).form('YYYY-MM-DD')
  //       showItem.deviceAgreements[i].agreement.dateTo = this.$moment(showItem.deviceAgreements[i].agreement.dateTo).form('YYYY-MM-DD')
  //     }
  //     this.item = showItem
  //   }
  },

  methods: {
    ...mapActions({
      del: 'excmdevice/del/del',
      reset: 'excmdevice/show/reset',
      retrieve: 'excmdevice/show/retrieve'
    }),

    downloadPDF (id, deviceSerialNumber) {
      this.$http
        .get('api/e_x_c_m_devices/' + id + '/getqrcode', {
          responseType: 'arraybuffer'
        })
        .then(response => {
          var myBlob = new Blob([response.data], { type: 'application/pdf' })
          var url = window.URL.createObjectURL(myBlob)
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          let fileName = 'device_' + deviceSerialNumber + '.pdf'
          a.download = fileName // Name file to download
          a.click()
          setTimeout(function () { window.URL.revokeObjectURL(url) }, 0)
        })
        .catch(error => {
          this.$swal({
            type: 'error',
            title: this.$t('notifications.store.errorTitle') + ' - ' + error,
            showConfirmButton: false,
            timer: 2500
          })
        })
    },

    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.del(item).then(() => this.$router.push({ name: 'EXCMDeviceList' }))
        }
      })
    },

    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_devices/' + this.getIdLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.$router.push({ name: 'EXCMDeviceList' })
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },

    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
